module.exports = "/images/vendor/flag-icon-css/flags/1x1/eg.svg?2ea321dd4b0a3aaf358950b90726466c";